import { isEmpty, isEmail, formatMobilePhone } from '@jjj/components';
import { isMobilePhone } from '../../helpers/validators';
import actions from './actions';
import { createReducer, getError } from '../../helpers/reducer';
import { keyBy } from '../../helpers/core';
import { t } from '../../i18n';

const initState = {
  editForm: null,
  loading: false,
  formInfo: {
    countries: [],
  },
  isEdit: false,
};

function onLoad(state) {
  return {
    ...state,
    loading: true,
    isEdit: false,
  };
}

function onLoadFormData(state, { payload }) {
  const { data } = payload;

  return {
    ...state,
    formInfo: { ...data },
  };
}

function validate(attr, value, params) {
  let error = '';

  if (attr === 'email') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.profile.email_label') });
    } else if (!isEmail(value)) {
      error = t('dash.validation.valid_error', { fieldName: t('dash.profile.email_label') });
    }
  }

  if (attr === 'phone') {
    if (!isMobilePhone(formatMobilePhone(value), params?.phoneNumberCountry)) {
      error = t('dash.validation.valid_error', { fieldName: t('dash.profile.phone_label') });
    }
  }

  if (attr === 'role') {
    if (isEmpty(value)) {
      error = t('dash.validation.select_a_field', { fieldName: t('dash.profile.role_label') });
    }
  }

  if (attr === 'country') {
    if (isEmpty(value)) {
      error = t('dash.validation.select_a_field', { fieldName: t('dash.profile.country_label') });
    }
  }

  if (attr === 'state') {
    if (isEmpty(value)) {
      error = t('dash.validation.select_a_field', { fieldName: t('dash.profile.state_label') });
    }
  }

  if (attr === 'first_name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.profile.first_name_label') });
    } else if (value.length >= 45) {
      error = t('dash.validation.max_length_error', { fieldName: t('dash.profile.first_name_label') });
    }
  }

  if (attr === 'last_name') {
    if (isEmpty(value)) {
      error = t('dash.validation.required_error', { fieldName: t('dash.profile.last_name_label') });
    } else if (value.length >= 45) {
      error = t('dash.validation.max_length_error', { fieldName: t('dash.profile.last_name_label') });
    }
  }

  return error;
}

function onLoadSuccess(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);

  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => {
      return {
        name: prop,
        value: data[prop],
        error: validate(prop, data[prop]),
        touched: false,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onClearStore() {
  return { ...initState };
}

function onEdit(state, { payload }) {
  const { data } = payload;
  const propsArray = Object.keys(data);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: data[prop],
      error: validate(prop, data[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    isEdit: true,
    editForm,
  };
}

function onSaveSuccess(state, { payload }) {
  const { data } = payload;
  const profile = data;

  return {
    ...state,
    profile,
    isEdit: false,
    editForm: null,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(entry[0], data),
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value, params } = payload;
  const { editForm } = state;
  const getValue = (val, attribute) => ({
    value: val,
    error: validate(attribute, val, params),
    name: attribute,
    touched: true,
  });

  if (!editForm[attr]) {
    editForm[attr] = getValue(value, attr);
  } else if (editForm[attr].value !== value) {
    return {
      ...state,
      editForm: {
        ...editForm,
        [attr]: getValue(value, attr),
      },
    };
  }

  return {
    ...state,
    editForm: { ...editForm },
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_FORM_DATA]: onLoadFormData,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.EDIT]: onEdit,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.TOUCH]: onTouch,
});
